const env = process.env.NODE_ENV
const isProd = env === 'production'

export const baseApiUrl = isProd ? 'https://internal.batamteknik.com/api/' : 'http://localhost:6025/api/'
export const uploaderUrl = isProd ? 'https://internal.batamteknik.com/upload/' : 'http://localhost:6027/'